import { z } from 'zod';
/** Income and expense categories are ledger accounts with subtype `category` and no currency. */
export const CATEGORY_KINDS = ['expense', 'income'];
export const categoryKindSchema = z.enum(CATEGORY_KINDS);
export const categoryNameSchema = z.string().trim().min(1).max(80);
export const categorySchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    kind: categoryKindSchema,
    archivedAt: z.string().nullable(),
    /** The parent of a subcategory (one level only, same kind); null for a top-level category. */
    parentId: z.string().uuid().nullable().default(null),
    /** How often this category was used in transactions the viewer can see (last 365 days). */
    usageCount: z.number().int(),
});
export const categoryListResponseSchema = z.object({ items: z.array(categorySchema) });
export const categoryListQuerySchema = z.object({
    kind: categoryKindSchema.optional(),
    q: z.string().trim().max(80).optional(),
    includeArchived: z
        .enum(['true', 'false'])
        .default('false')
        .transform((v) => v === 'true'),
});
export const createCategoryRequestSchema = z.object({
    name: categoryNameSchema,
    kind: categoryKindSchema,
    parentId: z.string().uuid().nullable().default(null),
});
/** Leaving `parentId` out keeps the parent; null makes the category top-level. */
export const updateCategoryRequestSchema = z.object({
    name: categoryNameSchema,
    parentId: z.string().uuid().nullable().optional(),
});
//# sourceMappingURL=categories.js.map